import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosDelete from "../axios/axios-delete";

const BASE_URL = "/subscribe-news";

export const SubscribeNewsAPI = Object.freeze({
  getAll: createAsyncThunk(
    "get/get-subscribe-news",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, {
          params,
        });
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  delete: createAsyncThunk(
    "delete/delete-subscribe-news",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`${BASE_URL}/${id}`);
        return response.data;
      } catch (err) {
        return rejectWithValue("Something went wrong");
      }
    }
  ),
});
